/* eslint-disable */
import { InfoWindow } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'
import './selectedStopInfo.scss'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export function SelectedStartInfo(props) {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  const connectedEmulatorRef = useRef(
    useEmulatorStore.getState().connectedEmulator
  )
  const tripDataRef = useRef(useEmulatorStore.getState().tripData)
  console.log('test@123 fromAddress', tripDataRef.current?.fromAddress)
  const fromAddress = tripDataRef.current?.fromAddress?.map(item => item.long_name).slice(0, 4).join(', ') || 'N/A'
  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.connectedEmulator,
        (connectedEmulator) => {
          connectedEmulatorRef.current = connectedEmulator
        }
      ),
    []
  )

  useEffect(
    () =>
      useEmulatorStore.subscribe(
        (state) => state.tripData,
        (tripData) => {
          tripDataRef.current = tripData
        }
      ),
    []
  )

  return (
    <>
      <InfoWindow
        position={{
          lat: connectedEmulatorRef.current?.startLat,
          lng: connectedEmulatorRef.current?.startLong
        }}
        onCloseClick={props.handleInfoWindowClose}
      >
        <div className="selectedStopBox">
          <div className="selectedStopInfo">
            <div className="container text-center">
              <div className="row">

                {/* DEPART ADDRESS HERE */}
                <div className="mt-0 mb-4">
                <h6 className="selectedStopHeader">Depart Address: </h6>
                <p
                    className="selectedStopPara"
                    style={{ textAlign: 'left !important' }}
                >
                  {fromAddress}
                </p>
                </div>

                {/* DEPART TIME HERE */}
                <div className="mt-0 mb-4">
                <h6 className="selectedStopHeader">Depart Time (CST)</h6>
                <p
                    className="selectedStopPara"
                    style={{ textAlign: 'left !important' }}
                >
                    {dayjs(connectedEmulatorRef?.current.departTimeInUtc).utcOffset(0).tz('America/Chicago').format('MMM D, YYYY, h:mm A')}
                </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </InfoWindow>
    </>
  )
}

function readableTime(time) {
  const date = new Date(time)
  const options = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
  }
  return date.toLocaleString('en-US', options)
}